<div class="row g-4 mb-3">
  @if ((isEditor || isOwner) && currentProject) {
    <div class="col-sm-auto">
      <div>
        <button type="button" (click)="openCreateConversationModal()" class="btn btn-success add-btn me-1" [disabled]="current_client.plan === null">
          <i class="ri-add-line align-bottom me-1"></i> Create new conversation </button>
        </div>
      </div>
    }
    @if (!currentProject) {
      <div class="col-sm-auto">
        <h1>Conversations</h1>
      </div>
    }
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end">
        <div class="search-box ms-2">
          <input type="text" class="form-control search" placeholder="Search by name or status..." [(ngModel)]="searchText" (input)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>

  <div class="table-responsive table-card mt-3 mb-1">
    <table class="table">
      <thead>
        <tr class="bg-light text-muted">
          <th scope="col" style="width: 50px;">No.</th>
          <th class="sort" listsortable="name" (listsort)="onSort($event)">Name</th>
          <th>First Name</th>
          <th>Last Name</th>
          <th>Email</th>
          @if (!currentProject) {
            <th>Project</th>
          }
          <th>ID</th>
          <th>Created By</th>
          <th>Create Date</th>
          <th>Status</th>
          @if (isAllow) {
            <th>Action</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (loading) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center"><app-loading-spinner></app-loading-spinner></td>
          </tr>
        }
        @if (!loading && conversations && conversations.length > 0) {
          @for (conversation of conversations; track conversation) {
            <tr>
              <td>{{ conversation.id }}</td>
              <td>
                <ngb-highlight [result]="conversation.name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="conversation.person.first_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="conversation.person.last_name" [term]="searchText"></ngb-highlight>
              </td>
              <td>
                <ngb-highlight [result]="conversation.person.email" [term]="searchText"></ngb-highlight>
              </td>
              @if (!currentProject) {
                <td>
                  <ngb-highlight [result]="conversation.project?.name" [term]="searchText"></ngb-highlight>
                </td>
              }
              <td>
                <ngb-highlight [result]="conversation.person.gov_id" [term]="searchText"></ngb-highlight>
              </td>
              <td>{{ conversation.created_by_user.person.first_name + ' ' + conversation.created_by_user.person.last_name }}</td>
              <td>{{ conversation.createdAt | date: 'medium' }}</td>
              <td>
                <span class="badge bg-{{ getStatusColor(conversation.status) }}-subtle text-{{ getStatusColor(conversation.status) }} fs-11">{{ conversation.status | titlecase }} {{ conversation.status === 'ANALYZING' ? getAnalyzingPrecent(conversation.ai_models) : '' }}</span>
              </td>
              @if (isAllow) {
                <td>
                  <div class="d-flex gap-2">
                    @if ((isEditor && conversation.status === 'WAITING') || isAnalyst || isOwner) {
                      <div class="edit">
                        <button class="btn btn-sm btn-success edit-item-btn" ngbTooltip="View Conversation" alt="View Conversation" [routerLink]="currentProject ? 'conversation/' + conversation.id : '/projects/' + conversation.project?.id + '/conversation/' + conversation.id">
                          <i class="ri-eye-line align-middle"></i>
                        </button>
                      </div>
                    }
                    @if ((isEditor && conversation.status === 'WAITING') || isOwner) {
                      <div class="remove">
                        <button (click)="openDeleteConversationModal(conversation, deleteConversationModal)" class="btn btn-sm btn-danger edit-item-btn" ngbTooltip="Remove Conversation" alt="Remove Conversation">
                          <i class="ri-delete-bin-line align-middle"></i>
                        </button>
                      </div>
                    }
                  </div>
                </td>
              }
            </tr>
          }
        }
        @if (!loading && conversations && conversations.length === 0) {
          <tr>
            <td [attr.colspan]="colspan" class="text-center">No conversations found.</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
  @if (!loading && conversations && conversations.length > 0) {
    <div class="row justify-content-md-between align-items-md-center">
      <div class="col col-sm-6">
        <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{totalConversations}} entries </div>
      </div>
      <div class="col col-sm-6">
        <div class="text-sm-right float-end listjs-pagination">
          <ngb-pagination [collectionSize]="totalConversations" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getConversations()"></ngb-pagination>
        </div>
      </div>
    </div>
  }

  <app-create-conversation #createConversationModal (conversationChanged)="refreshConversations()"></app-create-conversation>

  <ng-template #successModal let-modal>
    <div class="modal-content">
      <div class="modal-body text-center p-5">
        <div class="text-end">
          <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
        </div>
        <div class="mt-2">
          @if (success) {
            <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
          }
          @if (!success) {
            <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
          }
          <h4 class="mb-3 mt-4">{{ title }}</h4>
          <p class="text-muted mx-4 mb-0">{{ message }}</p>
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template #deleteConversationModal let-modal>
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="closeModal()"></button>
      </div>
      <div class="modal-body">
        <div class="mt-2 text-center">
          <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
          <div class="alert alert-danger">
            <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
          </div>
          <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Are you Sure You want to delete <span class="fw-semibold text-warning">{{ selectedConversation.name }} </span>?</h4>
          </div>
        </div>
        <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="closeModal()">Close</button>
          <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteConversation()" [disabled]="submitted && spinner">
            <span class="d-flex justify-content-center">
              @if (submitted && spinner) {
                <span class="spinner-border" role="status">
                  <span class="visually-hidden">Loading...</span>
                </span>
              }
              <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
            </span>
          </button>
        </div>
      </div>
    </div>
  </ng-template>